import { createContext } from 'react';

export type PersistedQueryParamsContextValue = {
  clearForCurrentRoute: () => void;
  clearForRoute: (path: string) => void;
  clearAll: () => void;
};

export const PersistedQueryParamsContext =
  createContext<PersistedQueryParamsContextValue | null>(null);
